import React from "react";
import { Box, IconButton } from "@mui/material";
import Icons from "../assets/Icons";

interface RightIconsProps {
  exportFilter: () => void;
  deleteFilter: () => void;
}

const RightIcons: React.FC<RightIconsProps> = ({
  exportFilter,
  deleteFilter,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
      }}
    >
      <IconButton
        size="small"
        sx={{
          color: "#22C55E",
          borderRadius: "4px",
        }}
        onClick={exportFilter}
      >
        <Icons.ExportIcon />
      </IconButton>

      <IconButton
        size="small"
        sx={{
          color: "#EF4444",
          borderRadius: "4px",
        }}
        onClick={deleteFilter}
      >
        <Icons.DeleteIcon />
      </IconButton>
    </Box>
  );
};

export default RightIcons;
